import React from "react";
import { Title, Text } from "@/components/ui/text";
import { PiXBold } from "react-icons/pi";
import { ActionIcon } from "@/components/ui/action-icon";
import { Dispatch } from "react";
import { SetStateAction } from "jotai";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
import MarkdownRenderer from "../Reactmarkdown/MarkDownRendere";
import { useState, useEffect } from "react";
import Link from "next/link";
import { routes } from "@/config/routes";
function getstatusheader(status: string) {
  switch (status.toLowerCase()) {
    case "bid":
      return "پیشنهاد جدید";
    case "information":
      return "اطلاع رسانی";
    case "warning":
      return "پیام اخطار";
    case "danger":
      return "پیام خطر";
    default:
      return status;
  }
}
const Notification = ({
  data,
  handleclose,
}: {
  data: any;
  handleclose: () => void;
}) => {
  const axiosAuth = useAxiosAuth();
  const [markdownContent, setMarkdownContent] = useState<string>("");
  const [cancelBid, setCancelbid] = useState(false);
  useEffect(() => {
    // Simulate fetching data from backend
    if (data.message) {
      setMarkdownContent(data.message);
    }
    if (data.message) {
      if ((data.message == "پیشنهاد شما لغو شد")) {
        setCancelbid(true);
      }
    }
  }, [data]);
  return (
    <>
      <div className="dark:bg-gray-100/90 overflow-hidden my-3 y-64 mx-3">
        <div className="col-span-full flex items-center justify-between pb-2 border-b-2 border-b-gray-200">
          <Title as="h4" className="font-semibold">
            {getstatusheader(data?.status)}
          </Title>
          <ActionIcon size="sm" variant="text" onClick={handleclose}>
            <PiXBold className="h-auto w-5" />
          </ActionIcon>
        </div>

        {!cancelBid && (
          <div className="mb-2 mt-3">
            {/* <Text >{data?.message}</Text> */}
            <MarkdownRenderer content={markdownContent} />
          </div>
        )}
        {cancelBid && (
          <div className="mb-2 mt-3">
            {/* <Text >{data?.message}</Text> */}
            درخواست شما بر روی 
            {" "}
            <Link className="text-primary-light border-b decoration-dashed mx-1" href={routes.invoice.details(data?.advertisement?.id)}>
            حواله‌ی
            {" "}{data?.advertisement?.id}{" "}
            </Link>
            لغو شد
          </div>
        )}
      </div>
    </>
  );
};

export default Notification;
